"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getList = exports.getListUnit = exports.getType = exports.categories = exports.valueRender = exports.IconFromCategory = void 0;
var react_1 = __importDefault(require("react"));
var link_1 = __importDefault(require("../../link"));
var LocalOfferOutlined_1 = __importDefault(require("@material-ui/icons/LocalOfferOutlined"));
var PhoneInTalkOutlined_1 = __importDefault(require("@material-ui/icons/PhoneInTalkOutlined"));
var CalendarTodayOutlined_1 = __importDefault(require("@material-ui/icons/CalendarTodayOutlined"));
var Link_1 = __importDefault(require("@material-ui/icons/Link"));
var MailOutline_1 = __importDefault(require("@material-ui/icons/MailOutline"));
var AssessmentOutlined_1 = __importDefault(require("@material-ui/icons/AssessmentOutlined"));
var CodeOutlined_1 = __importDefault(require("@material-ui/icons/CodeOutlined"));
var Type = __importStar(require("./type"));
var Text = __importStar(require("../../text"));
exports.IconFromCategory = function (_a) {
    var category = _a.category;
    if (category === Type.AdditionalPropertyCategory.Phone) {
        return react_1["default"].createElement(PhoneInTalkOutlined_1["default"], null);
    }
    if (category === Type.AdditionalPropertyCategory.Date) {
        return react_1["default"].createElement(CalendarTodayOutlined_1["default"], null);
    }
    if (category === Type.AdditionalPropertyCategory.Link) {
        return react_1["default"].createElement(Link_1["default"], null);
    }
    if (category === Type.AdditionalPropertyCategory.Email) {
        return react_1["default"].createElement(MailOutline_1["default"], null);
    }
    if (category === Type.AdditionalPropertyCategory.Amount) {
        return react_1["default"].createElement(AssessmentOutlined_1["default"], null);
    }
    if (category === Type.AdditionalPropertyCategory.Barcode) {
        return react_1["default"].createElement(CodeOutlined_1["default"], null);
    }
    return react_1["default"].createElement(LocalOfferOutlined_1["default"], null);
};
exports.valueRender = function (x) {
    if (x.type.id === Type.AdditionalPropertyCategory.Phone) {
        return (react_1["default"].createElement(link_1["default"], { to: "skype:" + x.value, external: true }, x.value));
    }
    if (x.type.id === Type.AdditionalPropertyCategory.ReferenceNumber) {
        return (react_1["default"].createElement("code", null,
            react_1["default"].createElement(Text.SeeMore, { text: x.value })));
    }
    if (x.type.id === Type.AdditionalPropertyCategory.Link) {
        return (react_1["default"].createElement(Text.SeeMore, { text: x.value },
            react_1["default"].createElement(link_1["default"], { external: true, to: x.value }, x.value)));
    }
    if (x.type.id === Type.AdditionalPropertyCategory.Email) {
        return (react_1["default"].createElement(Text.SeeMore, { text: x.value },
            react_1["default"].createElement(link_1["default"], { external: true, to: "mailto:" + x.value }, x.value)));
    }
    if (x.type.id === Type.AdditionalPropertyCategory.Barcode) {
        return (react_1["default"].createElement(Text.SeeMore, { text: x.value },
            react_1["default"].createElement(link_1["default"], { external: true, to: "https://app.digis.ch/barcode/qrcode?s=" +
                    encodeURIComponent(x.value) }, x.value)));
    }
    if (x.type.id === Type.AdditionalPropertyCategory.InternalLink) {
        return react_1["default"].createElement(link_1["default"], { to: x.value }, x.value);
    }
    return x.value;
};
exports.categories = [
    { id: Type.AdditionalPropertyCategory.Text, name: 'Text' },
    { id: Type.AdditionalPropertyCategory.Email, name: 'Email' },
    { id: Type.AdditionalPropertyCategory.Phone, name: 'Phone' },
    { id: Type.AdditionalPropertyCategory.Link, name: 'Link' },
    { id: Type.AdditionalPropertyCategory.Date, name: 'Date' },
    { id: Type.AdditionalPropertyCategory.Barcode, name: 'Barcode' },
    {
        id: Type.AdditionalPropertyCategory.ReferenceNumber,
        name: 'Reference Number'
    },
    { id: Type.AdditionalPropertyCategory.Amount, name: 'Amount' },
    { id: Type.AdditionalPropertyCategory.InternalLink, name: 'Internal Link' }
];
exports.getType = function (a) {
    return exports.categories.find(function (x) { return x.id === a; }) || exports.categories[0];
};
exports.getListUnit = function (l) {
    var type = exports.getType(l.type);
    return __assign(__assign({}, l), { type: type });
};
exports.getList = function (l) { return l.map(exports.getListUnit); };
